import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=6e876f04&scoped=true"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=6e876f04&prod&scoped=true&lang=css"
import style1 from "./updatePassword.vue?vue&type=style&index=1&id=6e876f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e876f04",
  null
  
)

export default component.exports